import React from 'react';
import styled, { css } from 'styled-components';

import Check from '@/components/atom/icon/Check';
import FloatingBottomSheet from '@/components/templates/f2f/common/FloatingBottomSheet';
import { HospitalSortFilter } from '@/parsers/f2f/common';
import theme from '@/styles/theme';

interface Props {
  selectedSortFilter: HospitalSortFilter;
  sortFilterList: HospitalSortFilter[];
  toggleModal: () => void;
  onClick: (sortFilter: HospitalSortFilter) => void;
}

const SearchSortTypeBottomSheet = ({
  selectedSortFilter,
  sortFilterList,
  toggleModal,
  onClick,
}: Props) => {
  return (
    <FloatingBottomSheet
      index={700}
      isOpened={true}
      onClickOverlay={toggleModal}
    >
      <Container>
        <Title>어떤 기준으로 정렬할까요?</Title>
        <Wrapper>
          {sortFilterList.map((sortFilter) => (
            <SortTypeItem
              key={`hospital-sortType-${sortFilter.getTitle()}`}
              isSelected={sortFilter.isSelected(selectedSortFilter.type)}
              sortFilter={sortFilter}
              onClick={onClick}
            />
          ))}
        </Wrapper>
      </Container>
    </FloatingBottomSheet>
  );
};

export default SearchSortTypeBottomSheet;

const Title = styled.span`
  padding: 0 24px 12px;
  ${({ theme }) => `
    ${theme.typography.UI20SB}
    color: ${theme.color.gray800};
    `}
`;

const SortTypeItem = ({
  sortFilter,
  isSelected,
  onClick,
}: Pick<Props, 'onClick'> & {
  sortFilter: HospitalSortFilter;
  isSelected: boolean;
}) => {
  return (
    <SortTypeItemWrapper onClick={() => onClick(sortFilter)}>
      <span>{sortFilter.getTitle()}</span>
      {isSelected && <Check fill={theme.color.primary500} />}
    </SortTypeItemWrapper>
  );
};

const Container = styled.div`
  ${({ theme }) => css`
    width: ${theme.client.isMobile ? 328 : 560}px;
    display: flex;
    flex-direction: column;
    padding: 12px 0 24px;
    & > h4 {
      ${theme.typography.UI20SB}
      color: ${theme.color.gray800};
      padding: 0 24px;
      margin-bottom: 8px;
    }
  `}
`;

const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
`;

const SortTypeItemWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
`;
